export default "/_next/static/videos/a6c6066ce163e38293c76b5e5a1a91dd.mp4";